import { Heading } from '@salecycle/ui-component-library';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { DrawerClose } from './DrawerClose';

const StyledHeader = styled.div`
  padding: 16px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.designToken.boxShadow0};
  h3 {
    font-size: 20px;
  }
`;

export interface DrawerHeaderProps {
  onClose: () => void;
}

export function DrawerHeader({ children, onClose }: PropsWithChildren<DrawerHeaderProps>) {
  return (
    <StyledHeader>
      <Heading variation="h3">{children}</Heading>
      <DrawerClose onClose={onClose} />
    </StyledHeader>
  );
}
